// Newport specific validations
export const objectRequiredWithGvlId = value => {
  return value && (value.id || value.gvl_id) ? null : { messageId: `required` };
};
